// A field rendered inside a repeater carries a synthetic, RHF-only `name`
// (e.g. `entries[0].foo_entries_123`) that must never be reverse-parsed to find
// its real location in `state`/`errors` — the underscore-containing schema names
// make that ambiguous. Every field builder instead reads/writes through the
// coordinates below, which CustomRepeater attaches directly onto the field object.
//
// `repeaterPath` carries the full chain of ancestor repeater array/index pairs,
// outermost first, so a repeater nested inside another repeater (inside another
// repeater, ...) resolves to the correct location at any depth — not just one
// level in. `childName` is the field's own real key within its immediate parent.
export interface RepeaterCoordinate {
  name: string;
  index: number;
}

export const getRepeaterValue = (
  state: any,
  path: RepeaterCoordinate[] | undefined,
  childName: string,
): any => {
  let node = state;
  for (const { name, index } of path || []) {
    node = node?.[name]?.[index];
    if (node === undefined || node === null) {
      return undefined;
    }
  }
  return node?.[childName];
};

export const setRepeaterValue = (
  state: any,
  path: RepeaterCoordinate[] | undefined,
  childName: string,
  value: any,
): any => {
  if (!path || path.length === 0) {
    return { ...state, [childName]: value };
  }
  const [{ name, index }, ...rest] = path;
  const currentArray = state?.[name] || [];
  const updatedArray = [...currentArray];
  while (updatedArray.length <= index) {
    updatedArray.push({});
  }
  updatedArray[index] = setRepeaterValue(updatedArray[index] || {}, rest, childName, value);
  return {
    ...state,
    [name]: updatedArray,
  };
};
